import { Outlet, useLocation } from 'ice';
import logoSVG from '@/assets/logo.svg';
import  '../global.less';

const Home = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/' 

  return (
    <div style={{ width: '100%', height: '100%' }}>
      {isHomePage ? (
        <div className='welcomeContainer'>
          <img src={logoSVG} alt="Welcome Logo" width={160}/>
        </div>
      ) : (
        <Outlet />
      )}
    </div>
  );
};

export default Home;
